import React, { useState, useEffect } from "react";
import { connect } from 'react-redux';
import VideoSection from "../../components/academy/videoSection/videoSection";
import SixYardAcademy from "../../components/academy/sixYardAcademy/sixYardAcademy";
import StaffSection from "../../components/academy/staffSection/staffSection";
import ScheduledCourses from "../../components/academy/scheduledCourses/scheduledCourses";
import PrivateTraining from "../../components/academy/privateTraining/privateTraining";
import GallerySection from "../../components/academy/gallerySection/gallerySection";
import classes from "../../components/academy/academy.module.css";
import { sixYardAxios } from "../../sixYardAxios";
import AcademyRegistrationForm from "../../components/academy/academyRegistrationForm/academyRegistrationForm";
import LoginModal from '../../components/containers/loginModal/loginModal';

function Academy(props) {
  const [academy, setAcademy] = useState([]);
  const [gallery, setGallery] = useState([]);
  const [staff, setStaff] = useState([]);
  const [activities, setActivities] = useState([]);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showAcademyRegistrationForm, setShowAcademyRegistrationForm] = useState(false);
  const [showLoginForm, setShowLoginForm] = useState(false);

  useEffect(() => {
    fetchAllData();
  }, [localStorage.getItem('language')]);

  useEffect(() => {
    props.isAuthenticated && setShowLoginForm(false);
  }, [props.isAuthenticated]);

  const fetchAllData = async () => {
    try {
      const [academyRes, staffRes, activitiesRes, galleryRes] = await Promise.all([
        sixYardAxios.get("/academy"),
        sixYardAxios.get("/academy/staff"),
        sixYardAxios.get("/academy/activities"),
        // sixYardAxios.get("/gallery/academy"),
      ]);

      setAcademy(academyRes.data.data);
      setStaff(staffRes.data.data);
      setActivities(activitiesRes.data.data);
      setGallery(academyRes.data.data?.gallery?.images);
    } catch (error) {
      console.error("Failed to fetch academy data:", error);
    } finally {
      setLoading(false);
    }
  };
  return (
    !showAcademyRegistrationForm ? (
      <div className={classes.academy}>
        {loading ? (
          <div>Loading...</div>
        ) : (
          <>
            <VideoSection src={academy.overview?.youtube_link}/>
            <SixYardAcademy academy={academy} />
            <StaffSection staff={staff} />
            <ScheduledCourses 
              academy={academy} 
              activities={activities} 
              setSelectedPlan={setSelectedPlan}
              setShowAcademyRegistrationForm={setShowAcademyRegistrationForm} 
              setSelectedLocation={setSelectedLocation}
              isAuthenticated={props.isAuthenticated} 
              setShowLoginForm={setShowLoginForm}
            />
            <PrivateTraining 
              academy={academy} 
              isAuthenticated={props.isAuthenticated} 
              setShowLoginForm={setShowLoginForm}
            />
            {gallery.length > 0 && <GallerySection gallery={gallery} />}
            {showLoginForm && <LoginModal setShowLoginForm={setShowLoginForm} currentPath={'/academy'} />}
          </>
        )}
      </div>
    ) : <div className={classes.academy}>
      <AcademyRegistrationForm 
        plans={academy?.subscriptions?.plans} 
        selectedPlan={selectedPlan} 
        academy={academy}
        setShowAcademyRegistrationForm={setShowAcademyRegistrationForm} 
        selectedLocation={selectedLocation}
        setSelectedLocation={setSelectedLocation}
      />
    </div>
  );
}
const mapStateToProps = state => ({
  isAuthenticated: state.auth.token !== null,
  language: state.home.selected_language,
});
export default connect(mapStateToProps)(Academy);
